import React from 'react';


const Card = ({ title, text, image, link }) => {
    return (
        <><a href={link || "#"}>
            <img src={image} className="img-thumbnail" alt="..." />
            </a>
            <p className="mb-0"><a href={link || "#"} className='text-info'>{title}</a></p>
        </>
    );
};

export default Card;